module.exports = __webpack_public_path__ + "img/producttop.ca236512.jpg";